import { render, staticRenderFns } from "./BaseAccordion.vue?vue&type=template&id=112f148b&scoped=true&"
import script from "./BaseAccordion.vue?vue&type=script&lang=ts&"
export * from "./BaseAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f148b",
  null
  
)

export default component.exports